import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { GetTokenParams, Token } from '@nx-frontend/shared/types';

export async function getToken({ workspaceId, noteId, userId }: GetTokenParams): Promise<Token> {
  return await axiosClient
    .post<Token>(
      `${generalEnv.noteServiceUrl}/v1/workspaces/${workspaceId}/texts/${noteId}/tokens`,
      {},
      {
        headers: {
          Authorization: `internal ${userId}:auto`,
        },
      }
    )
    .then((response) => response.data);
}
